import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { GateWay } from '../gateway.model';
import { GateWayAttributeActionTypes, GateWayAttributeActions } from '../actions/gateway-attribute.actions';

export interface GateWayMgtAttributeState {
  Loaded: boolean;
  Loading: boolean;
  entities: any;
}

export const initialState: GateWayMgtAttributeState = {
  Loaded: false,
  Loading: false,
  entities: null
};

export function reducer(
  state = initialState,
  action: GateWayAttributeActions
): GateWayMgtAttributeState {
  switch (action.type) {

    case GateWayAttributeActionTypes.UpsertMgtAttribute: {
      return {...state, Loaded: true, Loading: false, entities: action.payload};
    }

    case GateWayAttributeActionTypes.ReadMgtAttribute: {
      return {...state, Loaded: false, Loading: true, entities: action.payload};
    }

    case GateWayAttributeActionTypes.ReadMgtAttributeFail: {
      return {...state, Loaded: true, Loading: false, entities: action.payload};
    }

    default: {
      return state;
    }
  }
}

export const getGateWayMgtAttributeState = (state: GateWayMgtAttributeState) => state;
